import * as types from './actionTypes';
import { storageKeys } from '../constants/storageKeys';

export const resetState = () => ({
  type: types.RESET_STATE,
});

export const setViewer = (viewer) => ({
  type: types.SET_VIEWER,
  viewer
});

export const addMessage = (message) => ({
  type: types.ADD_MESSAGE,
  message
});


export const setTranscript = (transcript) => ({
  type: types.SET_TRANSCRIPT,
  transcript
});


export const toggleLoader = (loaderType, isLoading = undefined) => ({
  type: types.TOGGLE_LOADER,
  payload: { loaderType, isLoading }
});


export const setViewerLoading = (isLoading) => ({
  type: types.SET_VIEWER_LOADING,
  payload: isLoading,
});


export const abortAllLoaders = () => ({
  type: types.ABORT_ALL_LOADERS
});

export const addHistoryEntry = (entry) => ({
  type: types.ADD_HISTORY_ENTRY,
  entry
});

export const increaseHistoryPointer = () => ({
  type: types.INCREASE_HISTORY_POINTER
});

export const decreaseHistoryPointer = () => ({
  type: types.DECREASE_HISTORY_POINTER
});

export const setHistoryPointer = (pointer) => ({
  type: types.SET_HISTORY_POINTER,
  pointer
});

export const setProcessedJson = (processedJson) => ({
  type: types.SET_CURRENT_JSONBPMN,
  processedJson: processedJson
});

export const setCheckers = (checkers) => ({
  type: types.SET_CHECKERS,
  payload: checkers,
});

export const toggleCheckerSelection = (checkerId) => ({
  type: types.TOGGLE_CHECKER_SELECTION,
  payload: checkerId,
});

// Thunks

export const resetApp = () => (dispatch, getState) => {
  const { viewer } = getState();
  try {
    if (viewer) {
      viewer.clear();
      const definitions = viewer.getDefinitions?.();
      if (definitions && definitions.rootElements) {
        definitions.rootElements = [];
      }
    }
  } catch (e) {
    console.warn('Viewer clear failed during reset', e);
  }
  dispatch(resetState());
};

export const setCheckersPersist = (checkers) => (dispatch) => {
  dispatch(setCheckers(checkers));
  try {
    localStorage.setItem(storageKeys.CHECKERS, JSON.stringify(checkers));
  } catch {}
};

export const toggleCheckerSelectionPersist = (checkerId) => (dispatch, getState) => {
  const { checkers } = getState();
  const updated = checkers.map((checker) =>
    checker.id === checkerId ? { ...checker, selected: !checker.selected } : checker
  );
  dispatch(toggleCheckerSelection(checkerId));
  try {
    localStorage.setItem(storageKeys.CHECKERS, JSON.stringify(updated));
  } catch {}
};
